import styled, { css } from 'styled-components';
import { Link } from '../Link';
const withVariant = ({ variant = 'default' }) => {
    const variants = {
        default: css `
      background-color: var(--color-neutral-80);
      color: var(--color-neutral-130);
      svg {
        color: var(--color-neutral-120);
      }
    `,
        error: css `
      background-color: var(--color-feedback-error-80);
      color: var(--color-feedback-error-110);

      span {
        color: var(--color-feedback-error-110);
      }

      svg {
        color: var(--color-feedback-error-100);
      }
    `,
        success: css `
      background-color: var(--color-feedback-success-80);
      color: var(--color-feedback-success-110);

      span {
        color: var(--color-feedback-success-110);
      }

      svg {
        color: var(--color-feedback-success-100);
      }
    `,
        warning: css `
      background-color: var(--color-feedback-attention-80);
      color: var(--color-feedback-attention-110);

      span {
        color: var(--color-feedback-attention-110);
      }

      svg {
        color: var(--color-feedback-attention-100);
      }
    `,
        information: css `
      background-color: var(--color-feedback-info-80);
      color: var(--color-feedback-info-110);

      span {
        color: var(--color-feedback-info-110);
      }

      svg {
        color: var(--color-feedback-info-100);
      }
    `,
    };
    return variants[variant];
};
export const IconWrapper = styled.span `
  width: 24px;
  height: 24px;
`;
export const AlertboxContent = styled.section `
  display: flex;
  flex-direction: column;
  margin-left: var(--spacing-2);
`;
export const AlertboxDescription = styled.div `
  display: inline;
  font-size: var(--font-size-xxs);
  font-weight: var(--font-weight-regular);

  a {
    font-size: var(--font-size-xxs);
    font-weight: var(--font-weight-semibold);
    text-decoration: underline;
  }

  @media screen and (min-width: 840px) {
    font-size: var(--font-size-xs);

    a {
      font-size: var(--font-size-xs);
    }
  }
`;
export const ErrorLink = styled(Link) `
  color: var(--color-feedback-error-110);

  &:hover {
    color: var(--color-feedback-error-130);
  }
`;
export const SuccessLink = styled(Link) `
  color: var(--color-feedback-success-110);

  &:hover {
    color: var(--color-feedback-success-130);
  }
`;
export const WarningLink = styled(Link) `
  color: var(--color-feedback-attention-110);

  &:hover {
    color: var(--color-feedback-attention-130);
  }
`;
export const InfoLink = styled(Link) `
  color: var(--color-feedback-info-110);

  &:hover {
    color: var(--color-feedback-info-130);
  }
`;
export const AlertboxTitle = styled.span `
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-xxs);
  word-break: break-word;
  line-height: 24px;
  display: flex;
  align-items: center;
  ${withVariant}

  @media screen and (min-width: 840px) {
    font-size: var(--font-size-xs);
  }
`;
export const AlertboxWrapper = styled.div `
  border-radius: var(--border-radius-sm);
  padding: var(--spacing-2);
  font-family: var(--font-family);
  display: flex;
  flex-direction: column;
  ${withVariant}
`;
export const TimeWrapper = styled.div `
  display: flex;
  justify-content: flex-end;
  margin-top: var(--spacing-1);

  p {
    color: inherit;
  }
`;
export const ContentWrapper = styled.div `
  display: flex;
`;
